import React from 'react';
import spinner from '../assets/spinner.svg';

export const Spinner = () => {
  return <img src={spinner} alt="Carregando..." />;
};
